<template>
  <div>
  
    <v-container>
      <div>
        <CoverSection></CoverSection>
      </div>
      <div>
        <IndicatorsSection></IndicatorsSection>
      </div>
    </v-container>
    <div>
      <WorldSection></WorldSection>
    </div>
    <v-container>
      <div>
        <FunnelSection></FunnelSection>
      </div>
      <div>
        <PlatformsSection></PlatformsSection>
      </div>
      <div>
        <RegisterSection></RegisterSection>
      </div>
      <div>
        <TrustSection></TrustSection>
      </div>
    </v-container>
    <v-footer dark>
      <v-container class="py-12" dark>
        <div class="d-flex justify-space-between px-6 pb-9  flex-wrap">
          <div class="px-4">
            <v-img src="@/assets/logo.svg" width="100"></v-img>
            <div class="text-p">
              © 2015-{{ year }} The Media Trade<br>23.659.903/0001-84<br>{{ $t('footer.copy') }}
            </div>
          </div>
          <div class="d-flex ma-3 flex-md-row flex-column">
            <div class="d-flex flex-column align-start">
              <div class="text-h6 mx-4">{{ $t('footer.company.title') }}</div>
              <v-btn text v-for="(item, index) in $t('footer.company.links')" :key="index" :href="item.link">{{ item.text
              }}</v-btn>

            </div>
            <div class="d-flex flex-column align-start">
              <div class="text-h6 mx-4">{{ $t('footer.follow_us.title') }}</div>
              <v-btn text target="_blank" href="https://www.linkedin.com/company/media-trade"><v-icon
                  class="mr-2">mdi-linkedin</v-icon>LinkedIn <v-icon small
                  class="ml-6">mdi-arrow-top-right</v-icon></v-btn>

                  <v-btn text target="_blank" href="https://www.instagram.com/themediatrade/"><v-icon
                  class="mr-2">mdi-instagram</v-icon>Instagram <v-icon small
                  class="ml-6">mdi-arrow-top-right</v-icon></v-btn>

                  <v-btn text target="_blank" href="https://www.facebook.com/themediatrade"><v-icon
                  class="mr-2">mdi-facebook</v-icon>Facebook <v-icon small
                  class="ml-6">mdi-arrow-top-right</v-icon></v-btn>
              <v-btn color="white" large class="mx-4 mt-9 primary--text" href="https://store.themediatrade.com"
                target="_blank">The Media Store <v-icon small class="ml-6">mdi-arrow-top-right</v-icon></v-btn>
            </div>
          </div>
        </div>
        <div class="mx-n4">
          <v-btn text small to="/politicas-de-cookie-e-privacidade">{{
            $t('footer.privacy') }}</v-btn>
          <v-divider vertical></v-divider>
          <v-btn text small to="/politicas-de-cookie-e-privacidade">{{
            $t('footer.terms') }}</v-btn>
        </div>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
import moment from 'moment'
import CoverSection from '@/components/home/CoverSection.vue';
import IndicatorsSection from '@/components/home/IndicatorsSection.vue';
import WorldSection from '@/components/home/WorldSection.vue';
import FunnelSection from '../components/home/FunnelSection.vue';
import PlatformsSection from '@/components/home/PlatformsSection.vue';
import RegisterSection from '../components/home/RegisterSection.vue';
import TrustSection from '../components/home/TrustSection.vue';

export default {
  name: 'HomePage',

  components: {
    CoverSection,
    IndicatorsSection,
    WorldSection,
    FunnelSection,
    PlatformsSection,
    RegisterSection,
    TrustSection,
  },
  computed: {
    year(){
      return moment().format('Y')
    }
  }
}
</script>
